// extracted by mini-css-extract-plugin
export var activityContainer = "_im-0";
export var typingIndicatorContainer = "_im-1";
export var typingIndicatorDot = "_im-2";
export var wave = "_im-3";